module.exports = __webpack_public_path__ + "img/placeholder_lote_car.eddbe7ee.png";